<main
  class="mx-auto flex min-h-screen max-w-lg flex-col items-center justify-center gap-4 px-4 text-center"
>
  <pl-spinner [loading]="true" />
  <h1 class="text-2xl font-bold">{{ 'loggedOut.heading' | transloco }}</h1>
  <p>{{ 'loggedOut.body' | transloco }}</p>
  <button
    type="button"
    class="rounded-full px-4 py-2 text-sm font-semibold hover:bg-[var(--mat-sys-on-surface)]/10"
    (click)="returnToLogin()"
  >
    {{ 'loggedOut.return' | transloco }}
  </button>
</main>
